export default __webpack_public_path__ + "static/media/BG Copy.79a49956.svg";